"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireWildcard(require("react"));
var _DesignComponents = require("../DesignComponents/DesignComponents");
var _CompletedContext = require("../CompletedContext");
require("./TaskAnimation.css");
var _left_arrow = _interopRequireDefault(require("../assets/left_arrow.png"));
var _right_arrow = _interopRequireDefault(require("../assets/right_arrow.png"));
// https://www.w3.org/WAI/ARIA/apg/patterns/carousel/#basic-carousel-elements
var TaskAnimation = exports.default = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TaskAnimation, _Component);
  var _super = (0, _createSuper2.default)(TaskAnimation);
  function TaskAnimation(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TaskAnimation);
    _this = _super.call(this, props);
    _this.state = props.state || {};
    if (!_this.state.initialized) {
      _this.state.initialized = true;
      // Initial state is set here, since the constructor can be called more than once.
      _this.state.completed = false;
      _this.state.frame = 0;
      _this.state.playing = false;
    }
    _this.state.frame = 0; // Start on frame 0 every time

    _this.play = _this.queueNextFrame.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(TaskAnimation, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }
      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
    }
  }, {
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      // Notify the parent of our completion status
      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
      console.log("TaskAnimation componentDidMount", this.props.children[0].props);
      if (this.state.playing) {
        this.queueNextFrame();
      }
    }
  }, {
    key: "queueNextFrame",
    value: function queueNextFrame(curFrame) {
      var _curFrame,
        _this3 = this,
        _ref,
        _this$props$children$;
      curFrame = (_curFrame = curFrame) !== null && _curFrame !== void 0 ? _curFrame : this.state.frame;
      window.clearTimeout(this.timeout);
      this.timeout = window.setTimeout(function () {
        _this3.setState(function (state, props) {
          var frame = state.frame;
          var frames = props.children.length || 1;
          frame++;
          while (frame > frames) {
            frame -= frames;
          }
          if (frame === frames) {
            if (props.loop) {
              frame = 0;
            } else {
              frame = frames - 1;
            }
            if (!state.completed) {
              if (!props.loop) {
                return {
                  frame: frame,
                  completed: true,
                  playing: false
                };
              }
              if (state.playing) {
                _this3.queueNextFrame(frame);
              }
              return {
                frame: frame,
                completed: true
              };
            }
            if (!props.loop) {
              return {
                frame: frame,
                playing: false
              };
            }
          }
          if (state.playing) {
            _this3.queueNextFrame(frame);
          }
          return {
            frame: frame
          };
        });
      }, ((_ref = (_this$props$children$ = this.props.children[curFrame].props.frametime) !== null && _this$props$children$ !== void 0 ? _this$props$children$ : this.props.frametime) !== null && _ref !== void 0 ? _ref : 1) * 1000);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var children = this.props.children;
      if (typeof children !== "object" || children.length === undefined) {
        children = [children];
      }
      if (!this.props.accessibleLabel) {
        throw new Error("TaskAnimation: prop `accessibleLabel` is required.");
      }
      var alreadyTitles = {};
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "task task-animation",
        role: "region",
        "aria-roledescription": "carousel",
        "aria-label": this.props.accessibleLabel,
        style: (0, _objectSpread2.default)({}, this.props.style)
      }, !this.props.hidePlayButton && /*#__PURE__*/_react.default.createElement("div", {
        className: "controls"
      }, /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
        variant: "solid",
        color: "teal",
        style: {
          marginRight: '16px'
        },
        onClick: function onClick() {
          if (!_this4.state.playing) {
            _this4.queueNextFrame();
            _this4.setState(function (state, props) {
              return {
                playing: true,
                frame: state.frame >= props.children.length - 1 ? 0 : state.frame
              };
            });
          } else {
            _this4.setState({
              playing: false
            });
            window.clearTimeout(_this4.timeout);
          }
        }
      }, this.state.playing ? 'Pause' : 'Play')), /*#__PURE__*/_react.default.createElement("div", {
        className: "content-area"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "arrow-column"
      }, /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
        "aria-label": "Previous frame",
        variant: "solid",
        color: "teal",
        style: {
          marginRight: '16px'
        },
        disabled: this.state.frame === 0,
        onClick: function onClick() {
          _this4.setState(function (state) {
            return {
              frame: Math.max(0, state.frame - 1),
              playing: false
            };
          });
          window.clearTimeout(_this4.timeout);
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "arrow-image",
        src: _left_arrow.default
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "content",
        "aria-live": "polite"
      }, children.map(function (v, k) {
        var _v$props$title;
        var title = (_v$props$title = v.props.title) !== null && _v$props$title !== void 0 ? _v$props$title : v.props.accessibleLabel;
        if (alreadyTitles[title]) {
          throw new Error("TaskAnimation: slide ".concat(k, " does not have a unique title or accessible label. For slides with duplicate titles, put (x of n) at the end of each title e.g. (2 of 3)."));
        }
        alreadyTitles[title] = true;
        if (_this4.state.playing) {
          if (k === _this4.state.frame) {
            return /*#__PURE__*/_react.default.cloneElement(v, {
              key: "animation-frame-" + k,
              index: k
            });
          }
          if (k === _this4.state.frame - 1) {
            var _React$cloneElement;
            return /*#__PURE__*/_react.default.cloneElement(v, (_React$cloneElement = {
              key: "animation-frame-" + k,
              index: k
            }, (0, _defineProperty2.default)(_React$cloneElement, "aria-hidden", true), (0, _defineProperty2.default)(_React$cloneElement, "className", "animation-frame fadeout"), _React$cloneElement));
          }
        } else {
          if (k === _this4.state.frame) {
            return /*#__PURE__*/_react.default.cloneElement(v, {
              key: "animation-frame-" + k,
              index: k
            });
          }
        }
        return null;
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "arrow-column"
      }, /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
        "aria-label": "Next frame",
        variant: "solid",
        color: "teal",
        style: {
          marginRight: '16px'
        },
        disabled: this.state.frame >= this.props.children.length - 1,
        onClick: function onClick() {
          _this4.setState(function (state, props) {
            return {
              frame: Math.min(props.children.length - 1, state.frame + 1),
              playing: false,
              completed: state.completed || state.frame + 1 >= props.children.length - 1
            };
          });
          window.clearTimeout(_this4.timeout);
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "arrow-image",
        src: _right_arrow.default
      })))));
    }
  }]);
  return TaskAnimation;
}(_react.Component);
TaskAnimation.contextType = _CompletedContext.CompletedContext;
TaskAnimation.Frame = /*#__PURE__*/function (_Component2) {
  (0, _inherits2.default)(Frame, _Component2);
  var _super2 = (0, _createSuper2.default)(Frame);
  function Frame() {
    (0, _classCallCheck2.default)(this, Frame);
    return _super2.apply(this, arguments);
  }
  (0, _createClass2.default)(Frame, [{
    key: "render",
    value: function render() {
      if (!this.props.title && !this.props.accessibleLabel) {
        throw new Error("TaskAnimation.Frame: prop `title` or `accessibleLabel` is required.");
      }
      return /*#__PURE__*/_react.default.createElement("div", Object.assign({
        className: "animation-frame",
        role: "group",
        "aria-roledescription": "slide",
        "aria-label": this.props.title ? undefined : this.props.accessibleLabel,
        "aria-labelledby": this.props.title ? "slide-title-".concat(this.props.index) : undefined
      }, this.props), this.props.title && /*#__PURE__*/_react.default.createElement("h2", {
        id: "slide-title-".concat(this.props.index)
      }, this.props.title), this.props.children);
    }
  }]);
  return Frame;
}(_react.Component);